import { MeetingsAPI } from 'api'

export const fetchGoogleScopesForUser = async () => {
  return MeetingsAPI.get(`/google/calendar/oauth/scopes`).then(
    (response) => response.data
  )
}
